import React from "react";
import { ACTION_FORM_TYPE } from "config/constants";
import ActionLayout from "../ActionLayout";

const ProductAttributeEdit = () => {
  return <ActionLayout type={ACTION_FORM_TYPE.EDIT} />;
};

export default ProductAttributeEdit;
